// ItemRow.tsx
import ComboBoxFormik from '@/common/components/form/ComboBoxFormik';
import InputFormik from '@/common/components/form/InputFormik';
import { budgetItem, Budgetlabel } from '@/types/maintenance.type';
import { getWorkAndProducts, getWorkAndProductsParam } from '@/common/services/maintenance.api';
import { useFormikContext } from 'formik';
import { useEffect, useState } from 'react';
import AutoCompleteRenderAsyncFormik from '@/common/components/form/AutoCompleteRenderAsyncFormik';

type Props = {
    index: number;
    item: Budgetlabel;
    onRemoveClick: () => void;
    mode?: "table" | "mobile";
};

const ItemRow = ({ index, item, mode = "table" }: Props) => {
    const [quantity, setQuantity] = useState<number>();
    const [maximumApplication, setMaximumApplication] = useState<number>();
    const [options, setOptions] = useState<{ value: budgetItem, label: string }[]>([]);
    const [, setIsService] = useState(false);
    const { setFieldValue } = useFormikContext();

    useEffect(() => {
        async function fetch() {
            const data = (await getWorkAndProducts()).data;
            setOptions(data.map(budget => ({ label: budget.name, value: budget })));
        }
        fetch();
    }, []);

    useEffect(() => {
        setFieldValue(`name${index}`, item);
        setFieldValue(`quantity${index}`, item.quantity);
        setFieldValue(`type${index}`, item.type);
        setFieldValue(`outsourcedService${index}`, item.outsourcedService);
    }, [item, index, setFieldValue]);

    const loadOptions = async (search: string) => {
        const data = search
            ? (await getWorkAndProductsParam(search)).data
            : (await getWorkAndProducts()).data;
        return data.map(budget => ({ label: budget.name, value: budget }));
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleItem = (target: any) => {
        if (!target?.value.code && target?.value.maximumApplication) {
            setMaximumApplication(target.value.maximumApplication);
            setQuantity(undefined);
            setIsService(true);
            return;
        }
        setQuantity(target?.value.totalQuantity);
        setIsService(false);
    };

    const getPlaceholder = () => {
        if (!quantity && !maximumApplication) return '';
        if (quantity) return `${quantity} no estoque..`;
        return `Máximo de aplicação: ${maximumApplication || 1}`;
    };

    const optionsType = [
        { value: '', label: '-' },
        { value: 'Preventiva', label: 'Preventiva' },
        { value: 'Corretiva', label: 'Corretiva' },
        { value: 'misuse', label: 'Mau uso' }
    ];

    const outsourcedService = [
        { value: '', label: '-' },
        { value: 'Tercerizado', label: 'Tercerizado' },
        { value: 'Serviço Interno', label: 'Serviço Interno' }
    ];

    return mode === "table" ? (
        <>
            <td className="p-2 border">
                <AutoCompleteRenderAsyncFormik
                    label=""
                    name={`name${index}`}
                    loadOptions={loadOptions}
                    onChange={handleItem}
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    defaultValue={item?.name ? { label: item.name, value: item as any } : undefined}
                    options={options}
                    className="h-10"
                />
            </td>
            <td className="p-2 border">
                <InputFormik
                    label=""
                    name={`quantity${index}`}
                    type="number"
                    placeholder={getPlaceholder()}
                    className="h-10"
                />
            </td>
            <td className="p-2 border">
                <ComboBoxFormik
                    label=""
                    name={`type${index}`}
                    options={optionsType}
                    className="h-15"
                />
            </td>
            <td className="p-2 border align-top">
                <ComboBoxFormik
                    label=""
                    name={`outsourcedService${index}`}
                    options={outsourcedService}
                    className="h-15"
                />
            </td>
        </>
    ) : (
        <div className="grid gap-4">
            <div>
                <label className="block text-sm font-medium mb-1">Item</label>
                <AutoCompleteRenderAsyncFormik
                    label=""
                    name={`name${index}`}
                    loadOptions={loadOptions}
                    onChange={handleItem}
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    defaultValue={item?.name ? { label: item.name, value: item as any } : undefined}
                    options={options}
                />
            </div>
            <div>
                <label className="block text-sm font-medium mb-1">Quantidade</label>
                <InputFormik
                    label=""
                    name={`quantity${index}`}
                    type="number"
                    placeholder={getPlaceholder()}
                />
            </div>
            <div>
                <label className="block text-sm font-medium mb-1">Tipo</label>
                <ComboBoxFormik
                    label=""
                    name={`type${index}`}
                    options={optionsType}
                />
            </div>
            <div>
                <label className="">Serviço</label>
                <ComboBoxFormik
                    label=""
                    name={`outsourcedService${index}`}
                    options={outsourcedService}
                    className="h-10"
                />
            </div>
        </div>
    );
};


export default ItemRow;
